import React from 'react';
import RydHeaderDialogBox from '../widgets/RydHeaderDialogBox';
import './../rolls/PianoRoll.css';
import './RydTextInputDialog.css';
import { normalizeClassName } from '../../render/renderUtils';
import {
    keybindingsGlobalResume,
    keybindingsGlobalSuspend
} from '../../keybindings/dispatcher';

export function TrackNameDialog({
    label,
    value,
    setValue,
    readonly = false,
    extraCollapsedStyle = {}
}: {
    label: string,
    value: string,
    setValue: (value?: string) => void,
    readonly?: boolean,
    extraCollapsedStyle?: React.CSSProperties
}) {

    const [collapsed, setCollapsed] = React.useState(true);
    const [updatedValue, setUpdatedValue] = React.useState(value);

    if (collapsed) {
        return (<>
            <button onClick={!readonly ? () => setCollapsed(!collapsed) : undefined}
                style={extraCollapsedStyle}
                className={normalizeClassName(['ryd-text-input-dialog', readonly ? 'readonly' : 'editable'])}
            >
                {value}
            </button>
        </>);
    }

    return (
        <RydHeaderDialogBox closeCB={() => { setCollapsed(!collapsed); }}>
            <>
                <input
                    defaultValue={value}
                    onChange={(e) => setUpdatedValue(e.target.value)}
                    onFocus={keybindingsGlobalSuspend}
                    onBlur={keybindingsGlobalResume}
                />
                <button onClick={() => {
                    setValue(updatedValue);
                    setCollapsed(!collapsed);
                }}>OK</button>
            </>
        </RydHeaderDialogBox>
    );
}